import { useRef } from "react";
function useFileInput() {
  const ref = useRef(null);
  const open = () => ref.current?.click();

  return {
    ref,
    open,
  };
}

export default useFileInput;
